import { CreateEvent } from "./CreateEvent";
import { EditEvent } from "./EditEvent";

export default {
  create: CreateEvent,
  edit: EditEvent,
};
